import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { deleteIntervalFailed, deleteIntervalSuccessful } from '../actions';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* deleteInterval(action) {
  try {
    const {
      id,
      iId,
    } = action.payload;

    const url = `${BACKEND_URL}/proxy/subscription/v1/subscriptions/${id}/intervals/${iId}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteIntervalSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(deleteIntervalFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(deleteIntervalFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
